// src/pages/Login.js (Corrected)

import React, { useState, useEffect } from 'react'; // <-- Import useEffect
import { useNavigate } from 'react-router-dom';
import { useAuth, isPathAuthorized } from '../context/AuthContext';
import logo from '../assets/logo.jpg';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { handleLogin, isAuthenticated, user } = useAuth();
    const buildTime = window.__ENV__?.BUILD_TIME;
    const buildTimeLabel = buildTime
        ? new Date(buildTime).toLocaleString('en-US', {
              year: 'numeric', month: 'short', day: 'numeric',
              hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
          })
        : null;

    useEffect(() => {
        if (isAuthenticated) {
            const lastPath = localStorage.getItem("last_path");
            const AUTH_PATHS = ["/", "/login", "/forgot-password"];
            const validPath = lastPath && !AUTH_PATHS.includes(lastPath) && !lastPath.startsWith("/changepassword") && lastPath.length > 1;
            const authorizedPath = validPath && isPathAuthorized(lastPath, user);
            navigate(authorizedPath ? lastPath : "/welcome", { replace: true });
        }
    }, [isAuthenticated, user, navigate]);

    // If isAuthenticated is true, the useEffect will trigger navigation, 
    // but the component will still render the form briefly until navigation completes.
    // If you prefer to show nothing while authenticated, you can conditionally return null:
    if (isAuthenticated) {
        return <div id="login-page">Redirecting...</div>; 
    }
    // --------------------------------------------------------

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await handleLogin(username, password);
            // Redirection now handled by useEffect after state update
        } catch (err) {
            setError(err.message || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="login-page">
            <div className="login-form-container">
                <div className="logo-container"> 
                    <img src={logo} alt="Weave Logo" className="logo-img" draggable="false" />
                </div>
                <h2>Weave</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                    {error && <p className="login-error">{error}</p>}
                    <p style={{ textAlign: "center", marginTop: 10, fontSize: "0.85rem" }}>
                        <button
                            type="button"
                            onClick={() => navigate("/forgot-password")}
                            style={{
                                background: "none", border: "none", color: "#3b82f6",
                                cursor: "pointer", textDecoration: "underline", padding: 0,
                            }}
                        >
                            Forgot Password?
                        </button>
                    </p>
                </form>
                {buildTimeLabel && (
                    <p className="login-footer" style={{ textAlign: "center", marginTop: 16, fontSize: "0.75rem", color: "#9ca3af" }}>
                        Build: {buildTimeLabel}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Login;
